module.exports = __webpack_public_path__ + "media/images/save-title-b0a3abd3caaf2745405ef586642007d7.jpg";